<template>
    <div class='backup-wrapper'>
      <b-tabs class="h-100" pills v-if="isHavingScheduleBackup">
            <b-tab class="h-100"  @click="tabIndex=1">
              <template slot="title">
                  <span><screw-driver class="backup-icon-active icon-default screwdriver"></screw-driver></span>
                  <span class="title-header">Manual</span>
                </template>
              <manual-backup v-if="tabIndex == 1"></manual-backup>
            </b-tab>
            <b-tab class="h-100"  @click="tabIndex=2">
              <template slot="title">
                  <span><clock class="backup-icon-active icon-default clock"></clock></span>
                  <span class="title-header">Schedule</span>
                </template>
              <schedulebackup v-if="tabIndex == 2"></schedulebackup>
            </b-tab>
      </b-tabs>
      <manual-backup v-if="!isHavingScheduleBackup"></manual-backup>
      <router-view class="h-100"></router-view>
    </div>
</template>
<script>
import ManualBackup from './manualBackups';
import ScrewDriver from '../../assets/screwdriver.svg';
import Clock from '../../assets/clock.svg';
export default {
  name: "Backups",
   components: {
   	ManualBackup,
   	ScrewDriver,
   	Clock,
   	schedulebackup: () =>
   	  import(/* webpackChunkName: 'ScheduleBackup/index' */ '../addons/ScheduleBackup/index.js').then(
   	    ({ ScheduleBackups }) => ScheduleBackups
   	  ),
  },
  computed: {
    isHavingScheduleBackup() {
      let installedAddons = this.$store.getters.getInstalledAddons;
      return _.indexOf(installedAddons,'scheduleBackup') > -1;
    },
  },
  data(){
    return{
      tabIndex:1
    }
  }
};
</script>

<style lang="scss">
@import "../../sass/_mixins";
@import "../../sass/_variables";
.backup-wrapper{
      .nav-pills{
        border: 1px solid rgba(149, 152, 154, 0.34);
        @include Text-Style-33;
        background-color:$white-two;
        ul{
        height: 42px;
      }
        li{
          border-right: 1px solid rgba(149, 152, 154, 0.34);
        }
        a{
          color: rgba(68, 68, 68, 0.54) !important;
        }
        a.active{
          background-color: #FFFFFF;
          border-radius: unset;
          color: rgba(35, 134, 219, 1) !important;
          path{
            stroke: #2386db;
          }
          circle{
            stroke: #2386db;
          }
        }
      }
  }
  .backup-main{
    .btn-outline-secondary, .custom-select {
      color: rgba($greyish-brown, 0.87);
      @include Text-Style-41;
      background-color: $light-grey;
      border: solid 1px rgba($battleship-grey, 0.34);
    }
    .btn-outline-secondary:hover, .custom-select:hover {
        color: #fff;
        background-color: #6c757d;
        border-color: #6c757d;
    }
  }
  .backup-icon-active{
      width:18px;
      height:18px;
      float: left;
      margin-top: 2px;
  }
.title-header{
  @include Text-Style-18;
  margin-left: 5px;
}
</style>
